import { useEffect, useRef } from 'react';
import { parsePurify } from '../../../utils/parsePurify';
import TripDetailsSubHeading from '../../tripDetailsSubHeading/TripDetailsSubHeading';
import './itinerary.css';

// activeDay: the day being read aloud (highlighted and scrolled into view); -1 = none
export default function Itinerary({ data, activeDay = -1 }) {
    const dayRefs = useRef([]);

    useEffect(() => {
        if (activeDay >= 0) dayRefs.current[activeDay]?.scrollIntoView?.({ behavior: 'smooth', block: 'nearest' });
    }, [activeDay]);

    return (
        <div>
            {data?.map((dayData, dayIndex) => {
                return (
                    <div
                        key={dayIndex}
                        ref={(el) => (dayRefs.current[dayIndex] = el)}
                        className={`detailsItineraryDiv ${activeDay === dayIndex ? 'detailsItineraryReading' : ''}`}
                    >
                        <TripDetailsSubHeading text={`Day ${dayIndex} - ${dayData.dayHeading}`} />
                        <div className='detailsItineraryDayDec'>
                            <span className='detailsItineraryDayDecSpan'>{parsePurify(dayData.dayDescription)}</span>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
